import { Dropdown, Button } from 'antd'
import type { MenuProps } from 'antd'
import { GlobalOutlined, CheckOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'

// Compact DE/EN language switcher for the app headers. Persists the choice
// via i18next's LanguageDetector (localStorage key 'nc-language'), so the
// selection survives reloads and applies to admin + customer portal alike.
const LANGS = [
  { code: 'de', label: 'Deutsch', short: 'DE' },
  { code: 'en', label: 'English', short: 'EN' },
] as const

export default function LanguageSwitcher() {
  const { i18n } = useTranslation()
  // i18n.language can be a region variant (e.g. "en-US") — normalize to base.
  const current = (i18n.resolvedLanguage || i18n.language || 'de').slice(0, 2)

  const items: MenuProps['items'] = LANGS.map((l) => ({
    key: l.code,
    label: l.label,
    icon: l.code === current ? <CheckOutlined /> : <span style={{ display: 'inline-block', width: 14 }} />,
    onClick: () => { void i18n.changeLanguage(l.code) },
  }))

  const shortLabel = LANGS.find((l) => l.code === current)?.short ?? 'DE'

  return (
    <Dropdown menu={{ items }} placement="bottomRight" trigger={['click']}>
      <Button type="text" icon={<GlobalOutlined />} aria-label="Language">
        {shortLabel}
      </Button>
    </Dropdown>
  )
}
